<template>
  <div v-hotkey="keymap" class="">
    <div class="controls-inner">
      <div class="pane"  v-bind:style="{ flex: subPanesStatus.optionsOpen ? 'auto' : 'none' }">
        <nikud-options-pane :sub-panes-status="subPanesStatus" :modes-obj="modesObj" :edit-nikud-props="editNikudProps" />
      </div>
      <div class="pane" v-bind:class="(subPanesStatus.manualOpen && !(subPanesStatus.optionsOpen) && localShowNikudButtons) ? 'open-keyboard' : ''">
        <manual-nikud-pane :sub-panes-status="subPanesStatus" :modes-obj="modesObj" :edit-nikud-props="editNikudProps" />
      </div>
      <div v-if="useWelcomePane && showWelcome" class="welcome-pane p-2">
        <span @click="showWelcome = false" style="cursor: pointer; color: gray"><i-times></i-times></span>
        <p class="welcome-header mb-2">ברוכים הבאים</p>
        כדי לערוך את הניקוד, לחצו על המילה הרצויה
      </div>
    </div>
    <div id="changes-applied-msg" class="notify-msg" style="display:none;">
        <p class="f white">text will be filled in by code</p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NikudOptionsPane from './NikudOptionsPane'
import ManualNikudPane from './ManualNikudPane'
import nikudMixins from '@/mixins/nikudMixins'
import {SimpleVsProConfig} from '@/simpleVsProConfig.js'

export default {
  name: 'NikudPaneContainer',
  components: {
    NikudOptionsPane,
    ManualNikudPane
  },
  props: ['modesObj', 'editNikudProps'],
  mixins: [nikudMixins], // for modalOpen()
  data () {
    return {
      showWelcome: true, // only relevant in "Simple" Nakdan
      subPanesStatus: {
        optionsOpen: SimpleVsProConfig.NIKUD_PANES.START_OPEN,
        manualOpen: SimpleVsProConfig.NIKUD_PANES.START_OPEN
      },
      showKeyboard: false,
      keymap: {
        'shift+p': () => {
          if (!(this.modalOpen())) {
            if (this.subPanesStatus.manualOpen && !(this.subPanesStatus.optionsOpen)) {
              this.subPanesStatus.optionsOpen = true
            } else if (this.subPanesStatus.optionsOpen && !(this.subPanesStatus.manualOpen)) {
              this.subPanesStatus.manualOpen = true
            } else /* both already open */ this.subPanesStatus.manualOpen = false // MAY be desired
          }
        }
      }
    }
  },
  watch: { // both only relevant in the "Simple" Nakdan
    bothPanesClosed (newBothPanesClosed) {
      if (!newBothPanesClosed) this.showWelcome = false
    },
    localFirstClickOrDoubleClickDone (newLocalFirstClickOrDoubleClickDone) {
      if (newLocalFirstClickOrDoubleClickDone && this.bothPanesClosed) this.subPanesStatus.optionsOpen = true
    }
  },
  computed: {
    useWelcomePane () {
      return SimpleVsProConfig.NIKUD_PANES.USE_WELCOME
    },
    localShowNikudButtons () {
      return this.$store.state.postSubmissionOptions.showNikudButtons
    },
    // the below computed properties are only relevant in the "Simple" Nakdan
    bothPanesClosed () {
      return !(this.subPanesStatus.manualOpen) && !(this.subPanesStatus.optionsOpen)
    },
    localFirstClickOrDoubleClickDone () {
      return this.modesObj.firstClickOrDoubleClickDone
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  /* DocumentSettings-specific CSS goes here */
  .controls-inner {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .pane-title {
    background-color: #f6f6f6;
  }
  .item-list > li{
    position: relative;
    padding: 0 12px 5px 0;
  }
  .item-list p {
    margin-bottom: 0;
  }
  .item-list hr {
    margin-top: 2px;
    margin-bottom: 6px;
  }
  .item-list > li:after{
    position: absolute;
    right: 0;
    top: 0;
    content: "\F0D9";
    font-family: FontAwesome;
    color: #1b1b1b;
    font-size: 20px;
    line-height: 20px;
  }
  .second-checkboxes li {
    padding-right: 15px;
  }
  .notify-msg {
    position: fixed;
    left: 24px;
    bottom: 48px;
    width: 238px;
    height: 50px;
    padding: 15px 8px;
    text-align: center;
    border-radius: 3px;
    box-sizing: border-box;
    background-color: #494949;
    @media (max-width: 767px) {
      right: auto;
      left:10px;
      height: auto;
      padding: 12px 8px;
    }    
  }
  .notify-msg p{
    margin: 0;
    color: white;
  }
  .pane {
    border-radius: 4px;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.3);
  }
  .pane:not(:last-child) {
    margin-bottom: 13px;
  }
  .open-keyboard{
      height: calc(100% - 28px);
  }
  /* the classes below are only relevant in the "Simple" Nakdan */
  .welcome-pane {
    background-color: #d6ecff;
    border-radius: 4px;
  }
  .welcome-header {
    font-size: 24px;
  }
</style>
